var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.08 42.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#442c5c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 35.08,
    height: 42.44
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,9.43V9.36c.29-6.3,4.63-7,6.49-7h.11c2.3.06,6.22,1,6.49,7v.07c0,.06.61,6-2.1,9.18a5.5,5.5,0,0,1-4.4,1.88h-.09a5.48,5.48,0,0,1-4.39-1.88C10.39,15.48,11,9.48,11,9.43m6.41,13.44h.27a7.8,7.8,0,0,0,6-2.68c3.29-3.82,2.74-10.36,2.68-11-.21-4.68-2.36-6.93-4.14-8A9.24,9.24,0,0,0,17.63,0h-.15a9.31,9.31,0,0,0-4.59,1.2c-1.8,1.05-4,3.29-4.19,8-.06.62-.61,7.16,2.68,11a7.76,7.76,0,0,0,6,2.68",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.07,33.71v0c0-.08,0-.15,0-.22-.05-1.74-.16-5.81-3.86-7.11l-.09,0A24.68,24.68,0,0,1,24,23a1.12,1.12,0,0,0-1.6.29A1.2,1.2,0,0,0,22.7,25a26.08,26.08,0,0,0,7.8,3.66c2,.73,2.21,2.92,2.27,4.93a1.62,1.62,0,0,0,0,.22,18.14,18.14,0,0,1-.18,2.71,30.78,30.78,0,0,1-15.06,3.6A30.89,30.89,0,0,1,2.48,36.46a14.87,14.87,0,0,1-.18-2.71c0-.07,0-.14,0-.22.06-2,.28-4.19,2.27-4.92a26.68,26.68,0,0,0,7.8-3.67,1.21,1.21,0,0,0,.28-1.65A1.13,1.13,0,0,0,11.05,23,23.92,23.92,0,0,1,4,26.32l-.08,0C.17,27.66.06,31.73,0,33.46a1.55,1.55,0,0,1,0,.22v0a13.89,13.89,0,0,0,.44,4,1.11,1.11,0,0,0,.44.56c.26.17,6.4,4.2,16.67,4.2s16.41-4,16.67-4.2a1.11,1.11,0,0,0,.44-.56,14.34,14.34,0,0,0,.41-4",
    transform: "translate(0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetails);
export default __webpack_public_path__ + "static/media/personalDetails.9b5842c824c17c04a8ed192eaad710f2.svg";
export { ForwardRef as ReactComponent };